// extracted by mini-css-extract-plugin
export default {"toolbarButtonWidth":"36px","toolbarButtonMargin":"1px","toolbarDividerWidth":"1px","documentThumbnailListPadding":"3px"};